import { render } from "./DayNavigator.vue?vue&type=template&id=b8585ea8&scoped=true"
import script from "./DayNavigator.vue?vue&type=script&lang=js"
export * from "./DayNavigator.vue?vue&type=script&lang=js"

import "./DayNavigator.vue?vue&type=style&index=0&id=b8585ea8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8585ea8"]])

export default __exports__